import http from "./http";

//
export function registerSendCode(data) {
  return http({
    url: "/web/merchant/auth/register/send-verify-code",
    method: "POST",
    data,
  });
}

export function registerSendMobileCode(data) {
  return http({
    url: "/web/merchant/auth/register/send-sms-verify-code",
    method: "POST",
    data,
  });
}

export function getAiConfig() {
  return http({
    url: "/web/merchant/ai/getConfig",
    method: "POST",
  });
}

export function loginCheck() {
  return http({
    url: "/web/merchant/system/login/check",
    method: "POST",
  });
}

export function sendPwdCode(data) {
  return http({
    url: "/web/merchant/auth/reset-passwd/send-sms-verify-code",
    method: "POST",
    data,
  });
}

export function sendPwdEmailCode(data) {
  return http({
    url: "/web/merchant/auth/reset-passwd/send-verify-code",
    method: "POST",
    data,
  });
}

export function resetPwd(data) {
  return http({
    url: "/web/merchant/auth/reset-passwd",
    method: "POST",
    data,
  });
}

export function authBindShop(data) {
  return http({
    url: "/web/merchant/shop/bind-shop",
    method: "POST",
    data,
  });
}

export function getWxQrcode() {
  return http({
    url: "/web/merchant/auth/wx-qrcode",
    method: "get",
  });
}

export function verifyAccount(data) {
  return http({
    url: "/web/merchant/auth/register/verify-account",
    method: "POST",
    data,
  });
}
